var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{class:[
        ("" + _vm.classPrefix),
        _vm.row.__isHover && (_vm.classPrefix + "--hover"),
        _vm.row.__isStripe && (_vm.classPrefix + "--stripe-" + (_vm.row.__index % 2)),
        _vm.className ]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }